import { CreditCard, Star, ShieldCheck } from "lucide-react";

const TONE = {
  5: "bg-emerald-100 text-emerald-800 border-emerald-200",
  4: "bg-emerald-50 text-emerald-700 border-emerald-100",
  3: "bg-amber-50 text-amber-800 border-amber-200",
  2: "bg-orange-50 text-orange-800 border-orange-200",
  1: "bg-red-50 text-red-700 border-red-200",
  0: "bg-slate-100 text-slate-600 border-slate-200",
};

/**
 * Compact badge showing restaurant payment reliability.
 * @param {object} score - { stars, label, orders_paid, orders_awarded, payment_rate, avg_payment_hours }
 * @param {"sm"|"md"|"lg"} size
 * @param {boolean} withDetails - show sample size and avg hours
 */
export default function PaymentScoreBadge({ score, size = "sm", withDetails = false, testId }) {
  if (!score) return null;
  const stars = score.stars ?? 0;
  const tone = TONE[stars] || TONE[0];
  const sizes = {
    sm: "text-[10px] px-2 py-0.5 gap-1",
    md: "text-xs px-2.5 py-1 gap-1.5",
    lg: "text-sm px-3 py-1.5 gap-2",
  }[size];
  const icon = stars >= 4 ? ShieldCheck : CreditCard;
  const Icon = icon;
  return (
    <div className={`inline-flex items-center rounded-full border font-semibold ${tone} ${sizes}`} data-testid={testId || "payment-score-badge"} title="Affidabilità pagamenti dell'acquirente">
      <Icon className={`${size === "lg" ? "w-4 h-4" : "w-3 h-3"}`} />
      <span className="uppercase tracking-wider font-mono">{score.label}</span>
      {stars > 0 && (
        <span className="inline-flex items-center">
          {Array.from({ length: stars }).map((_, i) => (
            <Star key={`s-${i}`} className={`${size === "lg" ? "w-3 h-3" : "w-2.5 h-2.5"} fill-current`} />
          ))}
        </span>
      )}
      {withDetails && (score.orders_paid ?? 0) > 0 && (
        <span className="text-[10px] font-mono opacity-80 ml-1">
          · {score.orders_paid}/{score.orders_awarded}
          {score.avg_payment_hours != null && ` · ${score.avg_payment_hours}h`}
        </span>
      )}
    </div>
  );
}
